import { render, staticRenderFns } from "./TalentosCard.vue?vue&type=template&id=56351182&scoped=true&"
import script from "./TalentosCard.vue?vue&type=script&lang=js&"
export * from "./TalentosCard.vue?vue&type=script&lang=js&"
import style0 from "./TalentosCard.vue?vue&type=style&index=0&id=56351182&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56351182",
  null
  
)

export default component.exports